import axios from "axios";
import { configUrl } from "config";

export async function useCreateTopicwiseTest(topicwisetests) {
  console.log(topicwisetests, "topicwisetests");

  const combinedTopicTest = topicwisetests?.topics?.combinedTopicTest;
  const url = combinedTopicTest
    ? `${configUrl.AssessmentServer}/api/TopicWiseTest/CreateCombinedTopicsTest`
    : `${configUrl.AssessmentServer}/api/TopicWiseTest/createTests`;

  try {
    const response = await axios.post(url, topicwisetests);
    console.log(response);
    return response;
  } catch (error) {
    console.log(error);
    return error.response;
  }
}
